import type { MeProfileDto } from "@/shared/auth/authApi";

export function userHasPartnerRole(user: MeProfileDto | null | undefined): boolean {
    return !!user?.roles?.some((r) => r.code === "PARTNER");
}
